import { styled } from "styled-components";

export const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #383838;
  color: #fff;
  border-radius: 30px;
  cursor: pointer;
  font-size: 24px;
  width: 639px;
  height: 65px;
`;
